import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const PUBLIC_AUTH_KEYS_QUERY_KEY = 'publicAuthKeys';

export function useGetPublicAuthKeys({
	enabled,
	refetchOnWindowFocus = false,
	impersonationContext,
}: {
	enabled: boolean;
	refetchOnWindowFocus?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		refetchOnWindowFocus,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IAPIKeyReference[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `public/auth/key`,
				}),
				'GET'
			);
		},
		queryKey: [PUBLIC_AUTH_KEYS_QUERY_KEY, impersonationContext],
	});
}

export const invalidateGetPublicAuthKeys = ({
	impersonationContext,
}: {
	impersonationContext?: Api.IImpersonationContext;
}) => reactQueryClient.invalidateQueries({ queryKey: [PUBLIC_AUTH_KEYS_QUERY_KEY, impersonationContext] });
